export default __webpack_public_path__ + "static/media/henkel.748fcafb.png";